import { isDevelopmentBuild, isProductionBuild } from './build.js'
import { getApiBaseUrl, isApiConfigured } from './api.js'
import { trimSlash } from './trim.js'

export function getSigninApiBaseUrl() {
  const explicit = import.meta.env.VITE_SIGNIN_API_BASE_URL
  if (typeof explicit === 'string' && explicit.trim()) return trimSlash(explicit)
  if (isDevelopmentBuild()) return ''
  return getApiBaseUrl()
}

export function getGoogleClientId() {
  return (import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '').trim()
}

export function getSupabaseUrl() {
  return (import.meta.env.VITE_SUPABASE_URL ?? '').trim()
}

export function getSupabaseAnonKey() {
  return (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim()
}

export function isSupabaseConfigured() {
  return getSupabaseUrl().length > 0 && getSupabaseAnonKey().length > 0
}

export function isAuthDevBypass() {
  if (isProductionBuild()) return false
  return import.meta.env.VITE_AUTH_DEV_BYPASS === 'true'
}

export function getWhoamiPath() {
  const raw = import.meta.env.VITE_AUTH_WHOAMI_PATH
  if (typeof raw === 'string' && raw.trim()) return raw.trim()
  return '/api/auth/me'
}

export function isAuthEnforced() {
  if (isAuthDevBypass()) return false
  if (!isApiConfigured()) return false
  return true
}
